import React, {useContext, useState} from 'react';
import {Context} from "../store/reducer";

/**
 * 徒歩圏内の情報、空き家に関する情報の注釈を表示するポップアップ
 * @returns {false|JSX.Element}
 * @constructor
 */
const Component = ({ optionId }) => {
    
    const { state, dispatch } = useContext(Context);

    /**
     * 閉じる場合はフラグをtrueにする。
     */
    const closeModal = () => {
        dispatch({
            type    : 'SET_IS_EXPLANATION_POPUP_OPENED',
            category: optionId,
            payload: false
        })
    }
    
    const setContent = (id) => {
        
        if (id === "vis_95_1") {
            // 徒歩圏内の施設充実度
            return (
              <>
                  <section className="u-pb-xs">
                      <div className="u-fs-12 u-lh-sm u-pb-sm">
                          <p className="u-pb-xs">
                              「徒歩での暮らしやすさ」を都市のビッグデータから数値化した不動産周辺環境の評価指標です。広島県内の都市地域を対象に相対的な評価により50mメッシュごとにスコアを付与しています。
                          </p>
                          <h5>【データの概要】</h5>

                          <p className="u-pb-xs">
                              ある地点から徒歩で到達できる範囲に生活利便施設、商業・レジャー施設、教育・学び施設＊といった「都市のアメニティ」がどれだけ集積しているかを100点満点で評価しています。
                          </p>
                          <p className="u-pb-xs">
                              ＊施設の分類<br/>
                              生活利便施設：スーパー、コンビニ、ドラッグストア、医療施設、公園など
                              商業・レジャー施設：飲食店、カフェ、パン、大型商業施設、娯楽施設、スポーツ施設など
                              教育・学び施設：習い事教室、書店、文化施設、子育て施設など
                          </p>

                          <h5>【データの出典・整備時期】</h5>
                          <p className="u-pb-xs">
                              <ul className="u-fs-12">
                                  <li>・日建設計総合研究所が、国立大学法人一橋大学大学院ソーシャル・データサイエンス研究科（清水千弘教授）の監修のもと開発、提供したものです。</li>
                                  <li>・本指標は、株式会社ゼンリン提供の各種データ（施設位置情報、歩行者ネットワークデータ）及び都市に関するオープンデータを用いて算出されています。</li>
                                  <li> ・整備時期は令和5年12月です。</li>
                              </ul>
                          </p>

                          <h5> ＜計算手法＞</h5>
                          <p className="u-pb-xs">
                              <ul className="u-fs-12">
                                  <li>・徒歩15分で到達できる範囲を徒歩圏と設定し、ある地点から徒歩圏内に含まれる各施設の立地数（面積も一部考慮）を集計し、スコア化</li>
                                  <li> ・算出に際しては、各アメニティまでの距離による重みづけ（距離減衰）や、同一アメニティ数に応じた重みづけ（限界効用逓減）を加味</li>
                              </ul>
                          </p>
                      </div>
                  </section>
              </>
            );
        } else if (id === "vis_95_2") {
            // 徒歩圏内の高低差
            return (
              <>
                  <section className="u-pb-xs">
                      <div className="u-fs-12 u-lh-sm u-pb-sm">
                          <p className="u-pb-xs">
                              「徒歩圏内の高低差」を都市のビッグデータから数値化した不動産周辺環境の評価指標です。広島県内の都市地域を対象に相対的な評価により50mメッシュごとにスコアを付与しています。
                          </p>

                          <h5>【データの概要】</h5>
                          <p className="u-pb-xs">
                              ある地点から徒歩で到達できる範囲内の起伏の大きさ（高低差）を評価しています。
                          </p>
                          
                          <h5>【データの出典・整備時期】</h5>
                          <p className="u-pb-xs">
                              ・日建設計総合研究所が、国立大学法人一橋大学大学院ソーシャル・データサイエンス研究科（清水千弘教授）の監修のもと開発、提供したものです。
                              ・本指標の高低差は、基盤地図情報の標高データを用いて算出されています。
                              ・整備時期は令和5年12月です。
                          </p>

                          <h5>＜計算手法＞</h5>
                          <p className="u-pb-xs">
                              ・徒歩15分で到達できる範囲を徒歩圏と設定し、ある地点から徒歩圏内の最大高低差を算出し、スコア化
                          </p>
                      </div>
                  </section>
              </>
        );
        } else if (id === "vis_95_3") {
            // 徒歩圏内の緑比率
            return (
              <>
                  <section className="u-pb-xs">
                      <div className="u-fs-12 u-lh-sm u-pb-sm">
                          <p className="u-pb-xs">
                              「徒歩圏内の緑の豊富さ」を都市のビッグデータから数値化した不動産周辺環境の評価指標です。広島県内の都市地域を対象に相対的な評価により50mメッシュごとにスコアを付与しています。
                          </p>

                          <h5>【データの概要】</h5>
                              <p className="u-pb-xs">
                              ある地点から徒歩で到達できる範囲内の緑被率（エリア面積に占める、公園、街路樹、庭園、草地、農地等を含めた緑の面積）を評価しています。
                          </p>

                          <h5>【データの出典・整備時期】</h5>
                          <p className="u-pb-xs">
                              <ul className="u-fs-12">
                                  <li>・日建設計総合研究所が、国立大学法人一橋大学大学院ソーシャル・データサイエンス研究科（清水千弘教授）の監修のもと開発、提供したものです。</li>
                                  <li>・本指標の緑被率は、町丁目別緑被率オープンデータ（※）を用いて算出されています。
                                     <br /> ※清野 友規, 藤原 邦彦, 鶴見 隆太, Google Earth Engineを用いた町丁目別緑被率オープンデータ（全国版）の作成と評価,
                                  日本建築学会技術報告集, 2022, 28 巻, 68 号, p. 521-526,
                                      https://doi.org/10.3130/aijt.28.521</li>
                                      <li>・整備時期は令和5年12月です。</li>
                              </ul>
                          </p>

                          <h5>＜計算手法＞</h5>
                          <p className="u-pb-xs">
                              ・徒歩15分で到達できる範囲を徒歩圏と設定し、ある地点から徒歩圏内の緑被率を算出し、スコア化
                          </p>
                      </div>
                  </section>
              </>
            );
        } else if (id === "vis_95_4") {
            // 推定空き家の分布
            return (
              <>
                  
                  <section className="u-pb-xs">
                      <div className="u-fs-12 u-lh-sm u-pb-sm">
                          <p className="u-pb-xs">

                              広島県内の戸建住宅（個人契約に限る）を対象に、電力データの使用量及び電力契約の状況から住宅の利用状況を分析し、「利用実態のない」若しくは「日常的に居住していない」と推定される住宅を「推定空き家」として抽出したものです。
                          </p>
                          <p className="u-pb-xs">
                              データ利用上の取り決めにより具体的な数値を公開できないため、件数や割合の多寡をヒートマップで表示しています。
                          </p><p className="u-pb-xs">
                          空き家率は電力契約の状況などから抽出した戸建住宅（個人契約に限る）の件数を分母、推定空き家の件数を分子として算出しています。
                      </p>
                          <p className="u-pb-xs">
                              【データの出典・整備時期】<br/>
                              <ul className="u-fs-12">
                                  <li>・中国電力ネットワーク株式会社が保有する電気使用者に関するデータを加工して作成したものです。</li>
                                  <li>・整備時期は令和6年3月です。</li>
                              </ul>

                          </p>
                      </div>
                  </section>

              </>
            );
        } else if (id === "vis_95_7") {
            // マンションの管理状況の評価
            return (
              <>

                  <section className="u-pb-xs">
                      <div className="u-fs-12 u-lh-sm u-pb-sm">
                          <p className="u-pb-xs">
                              <p
                                className="u-pb-xs">一般社団法人マンション管理業協会が実施している「マンション管理適正評価制度」の評価結果を表示します。</p>
                              <p
                                className="u-pb-xs">「マンション管理適正評価制度」は、マンション管理組合の依頼に基づき、専門家が管理状態を５つのカテゴリー（管理組合体制、建築・設備、管理組合収支、耐震診断、生活関連）の３０項目について評価し、その結果を管理組合自らの責任で情報開示を行うものです。詳しくはマンション管理適正評価制度のサイトをご覧ください。
                              </p>
                              【データの出典・整備時期】<br />
                              <ul className="u-fs-12">
                                  <li>・マンション管理適正評価サイト（一般社団法人マンション管理業協会）で公開されている情報を取得しています。</li>
                                  <li>・整備時期はマンション管理適正サイトで提供されているデータに基づきます。</li>
                              </ul>
                          </p>
                      </div>
                  </section>

              </>
            );
        }


    }

    return (<>
        <div className="modal-first">
            <div className="modal-first-inner">

                {
                    setContent(optionId)
                }

                <p className="u-txt-c" onClick={closeModal}>
                    <span style={{"text-decoration": "underline", "cursor": "pointer"}}>閉じる</span>
                </p>
            </div>
        </div>
    </>);
}

export default Component
